// Single source of truth for all modal types
export const MODAL_TYPES = {
  // Call Flow
  CALL_CONFIRMED: 'CALL_CONFIRMED',
  TRANSCRIPTION_INTRODUCTION: 'TRANSCRIPTION_INTRODUCTION',
  
  // Navigation
  SMART_NAVIGATION: 'SMART_NAVIGATION',
  RESUME_TRANSCRIPTION: 'RESUME_TRANSCRIPTION',
  
  // Allocation Phase
  OPEN_ALLOCATIONS: 'OPEN_ALLOCATIONS',
  ALLOC_OVERVIEW: 'ALLOC_OVERVIEW',
  ALLOC_PERFORMANCE: 'ALLOC_PERFORMANCE',
  ALLOC_HOLDING: 'ALLOC_HOLDING',
  RETURN_REVIEW: 'RETURN_REVIEW',
  
  // Sales Reminders
  SALES_REMINDER_STOCK_OPTIONS: 'SALES_REMINDER_STOCK_OPTIONS',
  SALES_REMINDER_PLANNING_GOALS: 'SALES_REMINDER_PLANNING_GOALS',
  SALES_REMINDER_ALTERNATIVES: 'SALES_REMINDER_ALTERNATIVES',
  
  // Task Management
  TASK_CREATION: 'TASK_CREATION',
  POST_MEETING_TASKS: 'POST_MEETING_TASKS',
  
  // Demo Flow
  END_DEMO: 'END_DEMO',
  SHOW_DEBRIEFING_ROOM: 'SHOW_DEBRIEFING_ROOM',
  
  // Smart Focus
  SMART_FOCUS: 'SMART_FOCUS',
  
  // Estate Planning
  ESTATE_PLANNING: 'ESTATE_PLANNING',
  
  // AI Features
  AI_SIDEBAR_INTRODUCTION: 'AI_SIDEBAR_INTRODUCTION',

  // Asset Allocation Demo
  DEMO_ASSET_ALLOCATION_OVERVIEW: 'DEMO_ASSET_ALLOCATION_OVERVIEW',
  DEMO_ASSET_ALLOCATION_PERFORMANCE: 'DEMO_ASSET_ALLOCATION_PERFORMANCE',
  DEMO_ASSET_ALLOCATION_HOLDING: 'DEMO_ASSET_ALLOCATION_HOLDING',
  DEMO_ASSET_ALLOCATION_RETURN: 'DEMO_ASSET_ALLOCATION_RETURN',

  // Questionnaire
  SHARE_QUESTIONNAIRE: 'SHARE_QUESTIONNAIRE'
};

// Export as default for backward compatibility
export default MODAL_TYPES; 